import * as React from "react";
import styled from "@mui/material/styles/styled";
import { GenericButton } from "./genericButton";
import { useTranslate } from "../../hooks/useTranslate";
import { PatientColorMap } from "../../layout/patientColorMap";

//region [[ Styles ]]

const DisclaimerElementView = styled("div")(({ theme }) => ({}));

const DisclaimerDescription = styled("div")({
  fontSize: "16px",
  marginTop: "10px",
  marginBottom: "10px",
  fontWeight: 500,
  width: "100%",
  lineHeight: "24px",
  color: PatientColorMap.GradDark,
});

const ButtonArea = styled("div")({
  display: "flex",
  justifyContent: "flex-end",
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface DisclaimerElementProps {
  disclaimerText: string;
  onCloseDisclaimer?: (event) => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const DisclaimerText = ({ ...props }: DisclaimerElementProps) => {
  const { translate } = useTranslate();

  return (
    <DisclaimerElementView>
      <DisclaimerDescription>{props.disclaimerText}</DisclaimerDescription>
      {props.onCloseDisclaimer && (
        <ButtonArea>
          <GenericButton
            onClick={props.onCloseDisclaimer}
            label={translate("CLOSE_TEXT")}
          ></GenericButton>
        </ButtonArea>
      )}
    </DisclaimerElementView>
  );
};
